<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";
import { RouterLink } from "vue-router";
import RegionSearchDialog from "@/components/landing/region-search.vue";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-vue-next";

const scrolled = ref(false);
const dialogOpen = ref(false);

const isMac = computed(() => {
  if (typeof navigator !== "undefined") {
    return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
  }
  return false;
});

onMounted(() => {
  const handleScroll = () => {
    scrolled.value = window.scrollY > 10;
  };
  window.addEventListener("scroll", handleScroll);

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
});
</script>

<template>
  <header
    :class="[
      'fixed inset-x-0 top-0 z-50 transition-all duration-300 mx-2 ',
      scrolled ? 'pt-4' : '',
    ]"
  >
    <nav
      :class="[
        'mx-auto flex items-center justify-between transition-all duration-300',
        scrolled
          ? 'p-2 rounded-2xl bg-background/80 backdrop-blur-sm border border-border max-w-5xl'
          : 'py-6 max-w-7xl',
      ]"
      aria-label="Global"
    >
      <div class="flex flex-1">
        <RouterLink to="/" class="-m-1.5 p-1.5 flex items-center gap-x-2">
          <img src="https://cdn.jittr.app/logos/logo-white.png" alt="Clipr Logo" class="w-32 h-12 object-cover" />
          <!-- Jittr -->
        </RouterLink>
      </div>

      <div class="flex justify-end">
        <Button
          class="!h-8 gap-1.5 !rounded-full px-3 py-4 select-none shadow-[inset_4px_4px_8px_rgba(0,0,0,0.1),inset_-4px_-4px_8px_rgba(0,0,0,0.1)] cursor-pointer"
          @click="dialogOpen = true"
        >
          <Search :size="16" />

          <span class="font-sans text-sm font-medium sm:inline">
            Destination
          </span>

          <kbd
            v-if="isMac"
            class="pointer-events-none hidden sm:flex h-5 min-w-6 items-center justify-center gap-1 rounded-sm bg-white/10 px-1 font-sans text-[13px] font-normal shadow-[inset_0_-1px_2px] shadow-white/10 select-none"
          >
            ⌘K
          </kbd>
          <kbd
            v-else
            class="pointer-events-none hidden sm:flex h-5 min-w-6 items-center justify-center gap-1 rounded-sm bg-white/10 px-1 font-sans text-[13px] font-normal shadow-[inset_0_-1px_2px] shadow-white/10 select-none"
          >
            Ctrl K
          </kbd>
        </Button>

        <RegionSearchDialog v-model:open="dialogOpen" />
      </div>
    </nav>
  </header>
</template>
